/**
 * @format
 */

import React, { FunctionComponent, ReactElement, useEffect, useState } from 'react';
import { Dialog, DialogActions, DialogContent, DialogTitle } from '@material-ui/core';
import I18n from '../../../components/Translate/I18n';
import CustomTextButtom from '../../../components/Buttons/CustomTextButton';
import { ComponentTypeParam, SimCardServiceTypeItem } from '../../../interfaces/collections/SimCardServiceInterface';
import { ComponentParam } from './ComponentByGroup';
import { ComponentApiParam } from './ComponentApiParam';
import Typography from '@material-ui/core/Typography';
import { useDispatch, useSelector } from 'react-redux';
import { FeaturesAction } from '../../../modules/features/reducers';
import { ServicesMvneType } from '../../../modules/lib/hooks/useOperatorType';
import { FeatureVerbTypeMap } from '../../../modules/features/FeaturesTypes';
import SimCardInterface from '../../../interfaces/platform/SimCardInterface';
import GridContainer from '../../../components/Grid/GridContainer';
import GridItem from '../../../components/Grid/GridItem';
import Button from '@material-ui/core/Button';
import { ReactComponent as Cancel } from '../../../assets/themes/OPL/img/icons/Cancel.svg';
import { ComponentApiParamOnSimCard } from './ComponentApiParamOnSimCard';
import { SimCardTypeMappedOnProduct } from './mappedCustom/SimCardTypeMappedOnProduct';
import { SimCardTypeAwaitingActivation } from './opl/Check/SimCardTypeAwaitingActivation';

const _ = require('underscore');

type ComponentParamsDialogType = {
    open: boolean;
    definitionComponent: SimCardServiceTypeItem;
    isActivationMode: boolean;
    closeCallback: () => void;
    confirmCallback: (componentParam: ComponentParam) => void;
    simCardId: number;
    verbType: number;
    title?: string | null;
    simCard?: SimCardInterface;
    typeList?: Array<SimCardServiceTypeItem> | null;
    alreadySelectedValues?: any;
};

export const ComponentParamsDialog: FunctionComponent<ComponentParamsDialogType> = ({
    open,
    closeCallback,
    confirmCallback,
    definitionComponent,
    isActivationMode,
    simCardId,
    verbType,
    title,
    simCard,
    typeList,
    alreadySelectedValues,
}): React.ReactElement => {
    const dispatch = useDispatch();
    const titleDialog = isActivationMode ? 'simcard:f.activate_feature_with_name' : title ?? 'simcard:f.deactivate_feature_with_name';
    const features = useSelector((state: { featuresReducers: any }) => state.featuresReducers);
    const [componentParam, setComponentParam] = useState<ComponentParam>({} as ComponentParam);

    const [awaitingActivation, setAwaitingActivation] = useState<boolean>(false);
    useEffect(() => {
        if (features.type === FeaturesAction.FEATURES_ACTIVATE_WITH_PARAMETERS) {
            if (features.fieldName) {
                let objParams: Array<{ name: string; value: string | number | boolean }> = [];
                let putOnStack = !features.extraFieldName;
                if (componentParam.params) {
                    objParams = JSON.parse(componentParam.params);
                }
                for (let i = 0; i < objParams.length; i++) {
                    if (objParams[i].name === features.fieldName && !features.extraFieldName) {
                        objParams[i].value = features.selectedValue;
                        putOnStack = false;
                    }
                    if (objParams[i].name === features.fieldName && features.extraFieldName && features.fieldName !== 'amount') {
                        objParams[i].value = features.selectedValue;
                        putOnStack = false;
                    }
                }
                if (definitionComponent.serviceType === ServicesMvneType.BME && putOnStack) {
                    objParams.push({
                        name: features.fieldName,
                        value: features.selectedValue.toString(),
                    });
                } else if (putOnStack && definitionComponent.serviceType !== ServicesMvneType.BME) {
                    objParams.push({
                        name: features.fieldName,
                        value: features.selectedValue.toString(),
                    });
                }

                const newComponentParam = {} as ComponentParam;
                newComponentParam.params = JSON.stringify(objParams);
                if (features.extraFieldName) {
                    newComponentParam.extraAmount = features.selectedValue;
                    newComponentParam.extraPackage = features.extraFieldName;
                }
                setComponentParam(newComponentParam);
                dispatch({ type: FeaturesAction.FEATURES_ACTIVATE_WITH_PARAMETERS, name: null });
            }
        }
    }, [dispatch, features, componentParam, definitionComponent]);

    useEffect(() => {
        if (open) {
            setComponentParam({} as ComponentParam);
            setAwaitingActivation(false)
        }
    }, [open]);


    const onAwaitingActivationChange = ():void => {
        setAwaitingActivation(!awaitingActivation)
    }

    const selectDefaultCallback = (fieldName: string, value: string | number): void => {
        let objParams: Array<{ name: string; value: string | number | boolean }> = [];
        if (componentParam.params) {
            objParams = JSON.parse(componentParam.params);
        }
        objParams.push({
            name: fieldName,
            value: value,
        });
        const newComponentParam = {} as ComponentParam;
        newComponentParam.params = JSON.stringify(objParams);
        setComponentParam(newComponentParam);
    };

    const textCallback = (fieldName: string, value: string): void => {
        const newComponentParam = {} as ComponentParam;
        let objParams: Array<{ name: string; value: string | number | boolean }> = [];
        if (componentParam.params) {
            objParams = JSON.parse(componentParam.params);
        }
        let putOnStack = true;
        for (let i = 0; i < objParams.length; i++) {
            if (objParams[i].name === fieldName) {
                objParams[i].value = value;
                putOnStack = false;
                break;
            }
        }
        if (putOnStack) {
            objParams.push({
                name: fieldName,
                value: value,
            });
        }
        if (fieldName === 'extraPackageAmount') {
            newComponentParam.extraAmount = value;
        }
        if (fieldName === 'extraPackage') {
            newComponentParam.extraPackage = value;
        }
        newComponentParam.params = JSON.stringify(objParams);
        setComponentParam(newComponentParam);
    };

    let params: ComponentTypeParam | null = null;
    if (definitionComponent.simCardServiceTypeParam && definitionComponent.simCardServiceTypeParam.length > 0) {
        try {
            for (let i = 0; i < definitionComponent.simCardServiceTypeParam.length; i++) {
                if (definitionComponent.simCardServiceTypeParam[i].verb === verbType) {
                    params = JSON.parse(definitionComponent.simCardServiceTypeParam[i].parameters);
                }
            }
        } catch (e) {
            params = null;
        }
    }

    const handleBME = (): Array<{ name: string; value: string | number | boolean }> => {
        let objParams: Array<{ name: string; value: string | number | boolean }> = [];
        if (componentParam.params) {
            objParams = JSON.parse(componentParam.params);
        }
        _.map(params, (value: ComponentTypeParam, key: string) => {
            if (
                key !== 'LAST_MSISDN' &&
                !_.find(objParams, (element: { name: string; value: string | number | boolean }) => {
                    return element.name === key;
                })
            ) {
                if (value.default !== null) {
                    objParams.push({ name: key, value: value.default });
                }
            }
        });

        return objParams;
    };

    const handleSDG = (): Array<{ name: string; value: string | number | boolean }> => {
        let objParams: Array<{ name: string; value: string | number | boolean }> = [];
        let objParamsAlreadySelected: Array<{ name: string; value: string | number | boolean }> = [];
        if (componentParam.params) {
            objParams = JSON.parse(componentParam.params);
        }
        if (alreadySelectedValues && alreadySelectedValues.length > 0) {
            objParamsAlreadySelected = JSON.parse(alreadySelectedValues[0].value);
        }
        for (let i = 0; i < objParamsAlreadySelected.length; i++) {
            const obj1 = objParamsAlreadySelected[i];
            if (obj1.name !== 'LAST_MSISDN') {
                let obj2 = objParams.find((o) => o.name === obj1.name);

                if (obj2) {
                    if (obj2 && (obj2.value === 'true' || obj2.value === 'TRUE' || obj2.value === 'false' || obj2.value === 'FALSE')) {
                        obj2.value = obj2.value === 'true' || obj2.value === 'TRUE';
                    }
                    Object.assign(obj1, obj2);
                } else {
                    if (obj1 && (obj1.value === 'true' || obj1.value === 'TRUE' || obj1.value === 'false' || obj1.value === 'FALSE')) {
                        obj1.value = obj1.value === 'true' || obj1.value === 'TRUE';
                    }
                    objParams.push(obj1);
                }
            }
        }

        return objParams;
    };

    const activateCallback = (): void => {
        const isBME = definitionComponent.serviceType === 'BME';
        componentParam.componentName = definitionComponent.mainname;
        componentParam.simCardId = simCardId;
        componentParam.status = isActivationMode ? 1 : verbType === FeatureVerbTypeMap.DEACTIVATE ? 0 : 2;

        if (awaitingActivation){
            componentParam.status = 4;
        }

        let objParams: any = null;
        if (isBME) {
            objParams = handleBME();
        } else {
            objParams = handleSDG();
        }

        if (objParams) {
            let newComponentParam = { ...componentParam } as ComponentParam;
            newComponentParam.params = JSON.stringify(objParams);
            setComponentParam(newComponentParam);
            confirmCallback(newComponentParam);
        }
    };

    let paramHasValue = false;
    _.map(params, (value: ComponentTypeParam, key: string) => {
        if (key !== 'LAST_MSISDN') {
            paramHasValue = true;
        }
    });

    const allowExpiryDate = (name: string): boolean => {
        const allowChangeExpiryDateOnComponent = simCard ? simCard.allowChangeExpiryDateOnComponent : true;
        return (
            (name === 'balanceExpiryDateOffset' && allowChangeExpiryDateOnComponent) ||
            (name === 'walletExpiryDateOffset' && allowChangeExpiryDateOnComponent) ||
            (name !== 'walletExpiryDateOffset' && name !== 'balanceExpiryDateOffset')
        );
    };

    const packagePair: { items: Array<string> } | null = definitionComponent.packagePairs ? JSON.parse(definitionComponent.packagePairs) : null;

    const packagePairComponent = (packagePair: { items: Array<string> }): ReactElement => {
        const pair: string = packagePair.items[0];
        let extraPackage: SimCardServiceTypeItem | null;
        if (!typeList) {
            return <></>;
        }
        for (let i = 0; i < typeList.length; i++) {
            if (typeList[i].mainname === pair) {
                extraPackage = typeList[i];
            }
        }

        const extraParams = (extraPackage: SimCardServiceTypeItem | null): ComponentTypeParam | null => {
            if (extraPackage === null) {
                return null;
            }
            let params: ComponentTypeParam | null = null;
            if (extraPackage.simCardServiceTypeParam && extraPackage.simCardServiceTypeParam.length > 0) {
                try {
                    for (let i = 0; i < extraPackage.simCardServiceTypeParam.length; i++) {
                        if (extraPackage.simCardServiceTypeParam[i].verb === verbType) {
                            params = JSON.parse(extraPackage.simCardServiceTypeParam[i].parameters);
                        }
                    }
                } catch (e) {
                    params = null;
                }
            }
            return params;
        };

        return (
            <GridContainer>
                {_.map(params, (value: ComponentTypeParam, key: string) => {
                    if (key !== 'LAST_MSISDN' && allowExpiryDate(key) && key !== 'amount') {
                        return (
                            <GridItem xs={12}>
                                <ComponentApiParam key={key} params={value} name={key} textCallback={textCallback} />
                            </GridItem>
                        );
                    }
                    if (key === 'amount') {
                        const extraP = extraParams(extraPackage);
                        return (
                            <>
                                <GridItem xs={6}>
                                    <Typography>{definitionComponent.mainname}</Typography>
                                    <ComponentApiParam key={key} params={value} name={key} textCallback={textCallback} />
                                </GridItem>
                                {extraPackage && (
                                    <GridItem xs={6}>
                                        <Typography>{extraPackage.mainname}</Typography>
                                        {extraP &&
                                            _.map(extraP, (value2: ComponentTypeParam, key2: string) => {
                                                if (key2 === 'amount') {
                                                    return (
                                                        <ComponentApiParam
                                                            extraFieldName={extraPackage ? extraPackage.mainname : ''}
                                                            key={key}
                                                            params={value2}
                                                            name={key2}
                                                            textCallback={(fieldName: string, value: string): void => {
                                                                textCallback('extraPackageAmount', value);
                                                                textCallback('extraPackage', extraPackage ? extraPackage.mainname : '');
                                                            }}
                                                        />
                                                    );
                                                }
                                            })}
                                    </GridItem>
                                )}
                            </>
                        );
                    }
                })}
            </GridContainer>
        );
    };

    return (
        <Dialog open={open} maxWidth="md" fullWidth={true}>
            <DialogTitle id="alert-dialog-title">
                <GridContainer justifyContent={'space-between'}>
                    <GridItem xs={11}>
                        <h4>
                            <I18n trans={titleDialog} valueObject={{ componentName: definitionComponent.description }} />
                        </h4>
                    </GridItem>
                    <GridItem xs={1}>
                        <Button onClick={closeCallback} color="primary">
                            <Cancel width={24} height={24} />
                        </Button>
                    </GridItem>
                </GridContainer>
            </DialogTitle>
            <DialogContent>

            {params && definitionComponent.serviceType !== ServicesMvneType.MCBME && paramHasValue && (
                <>
                    <Typography variant="subtitle2">
                        <I18n trans="simcard:f.choose_correct_params" />
                    </Typography>
                    {packagePair === null &&
                        _.map(params, (value: ComponentTypeParam, key: string) => {
                            if (key !== 'LAST_MSISDN' && allowExpiryDate(key)) {
                                return (
                                    <ComponentApiParamOnSimCard
                                        key={key}
                                        params={value}
                                        name={key}
                                        textCallback={textCallback}
                                        alreadySelectedValues={alreadySelectedValues}
                                    />
                                );
                            }
                        })}
                    {packagePair !== null && typeList && packagePairComponent(packagePair)}
                </>
            )}
            {!paramHasValue && definitionComponent.serviceType !== ServicesMvneType.MCBME && verbType === FeatureVerbTypeMap.DEACTIVATE && (
                <>
                    <Typography variant="subtitle2">
                        <I18n trans="simcard:f.confirm_remove_component" />
                    </Typography>
                </>
            )}
            {!params && isActivationMode && definitionComponent.serviceType !== ServicesMvneType.MCBME && (
                <>
                    <Typography variant="subtitle2" align="center">
                        <I18n trans="simcard:f.confirm_activate_component" />
                    </Typography>

                </>
            )}
            {isActivationMode && definitionComponent.serviceType === ServicesMvneType.MCBME && (
                <>
                    <Typography variant="subtitle2" align="center">
                        <I18n trans="simcard:f.confirm_activate_component" />
                    </Typography>
                    <SimCardTypeMappedOnProduct simCardServiceType={definitionComponent} />
                </>
            )}
                {definitionComponent && definitionComponent.allowWaitingForActivation && (
                    <SimCardTypeAwaitingActivation checked={awaitingActivation} onChange={onAwaitingActivationChange}/>
                )}

            </DialogContent>

            <DialogActions>
                <CustomTextButtom
                    callback={activateCallback}
                    callbackParam={{}}
                    label={isActivationMode ? 'simcard:f.activate_component' : 'simcard:f.save'}
                    size="sm"
                />
            </DialogActions>
        </Dialog>
    );
};
